import React from 'react';

import { Card, Collapse, Table } from 'antd';

import { AgroReportDaily } from '../../../models/AgroReport';

const { Panel } = Collapse;

interface Props {
    daily: AgroReportDaily[];
}

const columns = [
    { title: 'Дата', dataIndex: 'date', key: 'date' },
    { title: 'Ср. T, °C', dataIndex: 'avg_temp', key: 'avg_temp', render: (v: number) => v?.toFixed(1) },
    { title: 'Мин. T, °C', dataIndex: 'min_temp', key: 'min_temp', render: (v: number) => v?.toFixed(1) },
    { title: 'Макс. T, °C', dataIndex: 'max_temp', key: 'max_temp', render: (v: number) => v?.toFixed(1) },
    { title: 'Осадки, мм', dataIndex: 'precip', key: 'precip', render: (v: number) => v?.toFixed(1) },
    { title: 'СЭТ, °C·дн', dataIndex: 'sat', key: 'sat', render: (v: number) => v?.toFixed(0) },
];

export default function DailyDetails(props: Props) {
    if (!props.daily || props.daily.length === 0) {
        return null;
    }

    return (
        <Collapse style={{ marginBottom: 16 }}>
            <Panel header={`Подробно по дням (${props.daily.length} записей)`} key="1">
                <Table
                    dataSource={props.daily.map((d, i) => ({ ...d, key: i }))}
                    columns={columns}
                    size="small"
                    pagination={{ pageSize: 31 }}
                    scroll={{ y: 400 }}
                />
            </Panel>
        </Collapse>
    );
}
